export default __webpack_public_path__ + "static/media/jordan_8.285af353.png";